function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToggleOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 16
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 797"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.566)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 16,
  "data-name": "Rectangle 132",
  rx: 8,
  style: {
    fill: "#62b866"
  },
  transform: "translate(.566)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  "data-name": "Rectangle 133",
  rx: 6,
  style: {
    fill: "#fff"
  },
  transform: "translate(24.566 2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "m1519.027 2202.889 3.655 3.655 6.4-6.4",
  style: {
    fill: "none",
    stroke: "#fff"
  },
  transform: "translate(-1515.027 -2195.344)"
})));
export { SvgToggleOn as ReactComponent };
export default __webpack_public_path__ + "images/Toggle_On.29f04b3b.svg";